/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_A_ConversationInputs */

const en_select_a_conversation = /** @type {(inputs: Select_A_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a conversation`)
};

const es_select_a_conversation = /** @type {(inputs: Select_A_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona una conversación`)
};

const fr_select_a_conversation = /** @type {(inputs: Select_A_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez une conversation`)
};

const de_select_a_conversation = /** @type {(inputs: Select_A_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle eine Unterhaltung`)
};

const ja_select_a_conversation = /** @type {(inputs: Select_A_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会話を選択してください`)
};

const zh_select_a_conversation = /** @type {(inputs: Select_A_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择一个对话`)
};

const ar_select_a_conversation = /** @type {(inputs: Select_A_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حدد محادثة`)
};

const id_select_a_conversation = /** @type {(inputs: Select_A_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih percakapan`)
};

const it_select_a_conversation = /** @type {(inputs: Select_A_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona una conversazione`)
};

const ru_select_a_conversation = /** @type {(inputs: Select_A_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите беседу`)
};

const pt_select_a_conversation = /** @type {(inputs: Select_A_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione uma conversa`)
};

const ko_select_a_conversation = /** @type {(inputs: Select_A_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대화를 선택하세요`)
};

/**
* | output |
* | --- |
* | "Select a conversation" |
*
* @param {Select_A_ConversationInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const select_a_conversation = /** @type {((inputs?: Select_A_ConversationInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_A_ConversationInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_select_a_conversation(inputs)
	if (locale === "es") return es_select_a_conversation(inputs)
	if (locale === "fr") return fr_select_a_conversation(inputs)
	if (locale === "de") return de_select_a_conversation(inputs)
	if (locale === "ja") return ja_select_a_conversation(inputs)
	if (locale === "zh") return zh_select_a_conversation(inputs)
	if (locale === "ar") return ar_select_a_conversation(inputs)
	if (locale === "id") return id_select_a_conversation(inputs)
	if (locale === "it") return it_select_a_conversation(inputs)
	if (locale === "ru") return ru_select_a_conversation(inputs)
	if (locale === "pt") return pt_select_a_conversation(inputs)
	return ko_select_a_conversation(inputs)
});